/** Copy for error screens. */
export const errorCopy = {
  notFound: {
    title: 'Page not found',
    body: 'The page you were looking for does not exist or has moved.',
    home: 'Go to the dashboard',
  },
  unexpected: {
    title: 'Something went wrong',
    body: 'An unexpected error occurred. Please try again.',
    referenceLabel: 'Reference ID',
  },
} as const;
